import React from 'react';
import {
  AddOne,
  AlphabeticalSorting,
  ArrowLeft,
  AtSign,
  Attention,
  BranchOne,
  Check,
  CheckOne,
  CheckSmall,
  ClickToFold,
  Clipboard,
  Close,
  CloseOne,
  CloseSmall,
  CloseWifi,
  Comment,
  Comments,
  CopyOne,
  CopyLink,
  Cycle,
  Delete,
  Detection,
  DoneAll,
  Dot,
  Down,
  Download,
  DownloadThree,
  UploadThree,
  Drag,
  Edit,
  EveryUser,
  ExpandTextInput,
  FolderPlus,
  FileCode,
  FileText,
  Filter,
  HamburgerButton,
  HandleX,
  HeadsetOne,
  Help,
  Inbox,
  Key,
  Left,
  LinkOne,
  LinkTwo,
  ListTop,
  LoadingFour,
  Lock,
  Login,
  Logout,
  MoreOne,
  Next,
  Paperclip,
  PayCodeOne,
  Play,
  PlayOne,
  PlayCycle,
  PreviewCloseOne,
  PreviewOpen,
  Redo,
  Refresh,
  Return,
  Right,
  RightBar,
  RobotOne,
  STurnLeft,
  Send,
  SettingTwo,
  SlightlySmilingFace,
  SpeakerOne,
  Time,
  Tool,
  Toolkit,
  Unlock,
  Up,
  ViewList,
  ListView,
  CodeBrackets,
  CodeOne,
  ShareThree,
  Terminal,
  Pencil,
  Timer,
  User,
  Me,
  Info,
  AdjacentItem,
  Lightning,
  VerticalTidyUp,
  BookOne,
  Undo,
  CheckCorrect,
  GoodTwo,
  Group,
  Optimize,
  Server,
  WebPage,
  Worker,
  International,
  Round,
  FullScreenTwo,
  OffScreenTwo,
  UserBusiness,
  CalendarThree,
  ThinkingProblem,
  DocAdd,
  AdProduct,
  AfferentThree,
  EfferentThree,
  EfferentFour,
  PeopleRight,
  LinkRight,
  Plus,
  Camera,
  FileSearchTwo,
  FileSuccess,
  ArrowRight,
  LinkIn,
  System,
  ImageFiles,
  FileEditing,
  TextRecognition,
  Compression,
  AudioFile,
} from '@icon-park/react';
import { IIconProps } from '@icon-park/react/lib/runtime';

import './index.less';

import { getDefaultIfUndefined } from '../../../utils/typeUtil';

import { ReactComponent as Search } from './search.svg';
import { ReactComponent as Telegram } from './telegram_line.svg';
import { ReactComponent as WhatsApp } from './whatsapp_line.svg';
import { ReactComponent as Viber } from './viber_line.svg';
import { ReactComponent as LiveChat } from './livechat_line.svg';
import { ReactComponent as Elma365 } from './elma365_line.svg';
import { ReactComponent as Confluence } from './confluence_line.svg';
import { ReactComponent as CodeBracketsTwo } from './code-brackets.svg';
import { ReactComponent as GuardrailInput } from './guardrail-input.svg';
import { ReactComponent as GuardrailOutput } from './guardrail-output.svg';

const SIZE_DEFAULT = 24;
const COLOR_DEFAULT = '#A4A4A4';
const MAIN_CLASS_NAME = 'ib-icon';

export type IbIconName =
  | 'attention'
  | 'compression'
  | 'paperclip'
  | 'add-one'
  | 'every-user'
  | 'comment'
  | 'comments'
  | 'cycle'
  | 'speaker-one'
  | 'branch-one'
  | 'inbox'
  | 'key'
  | 'check-one'
  | 'check-small'
  | 'edit'
  | 'slightly-smiling-face'
  | 'view-list'
  | 'list-view'
  | 'code-brackets'
  | 'check'
  | 'delete'
  | 'link-two'
  | 'headset-one'
  | 'alphabetical-sorting'
  | 'at-sign'
  | 'lock'
  | 'unlock'
  | 'next'
  | 'send'
  | 'up'
  | 'done-all'
  | 'down'
  | 'search'
  | 'setting-two'
  | 'help'
  | 'guardrail-input'
  | 'guardrail-output'
  | 'login'
  | 'logout'
  | 'pay-code-one'
  | 'code-one'
  | 'filter'
  | 'close-small'
  | 'close'
  | 'more-one'
  | 'right-bar'
  | 'hamburger-button'
  | 'arrow-left'
  | 'refresh'
  | 'preview-open'
  | 'preview-close-one'
  | 'return'
  | 'close-wifi'
  | 'time'
  | 'tool'
  | 'toolkit'
  | 'dot'
  | 'drag'
  | 'play'
  | 'play-one'
  | 'play-cycle'
  | 'copy-one'
  | 'copy-link'
  | 'detection'
  | 'left'
  | 'right'
  | 'robot-one'
  | 'close-one'
  | 'download'
  | 'download-three'
  | 'upload-three'
  | 'list-top'
  | 'handle-x'
  | 's-turn-left'
  | 'redo'
  | 'click-to-fold'
  | 'expand-text-input'
  | 'loading-four'
  | 'link-one'
  | 'folder-plus'
  | 'file-code'
  | 'file-text'
  | 'share-three'
  | 'terminal'
  | 'pencil'
  | 'timer'
  | 'user'
  | 'me'
  | 'info'
  | 'adjacent-item'
  | 'lightning'
  | 'vertical-tidy-up'
  | 'book-one'
  | 'undo'
  | 'check-correct'
  | 'telegram'
  | 'viber'
  | 'whatsapp'
  | 'livechat'
  | 'directline'
  | 'elma365'
  | 'good-two'
  | 'group'
  | 'optimize'
  | 'server'
  | 'web-page'
  | 'worker'
  | 'international'
  | 'confluence'
  | 'round'
  | 'clipboard'
  | 'fullscreen-two'
  | 'offscreen-two'
  | 'user-business'
  | 'calendar-three'
  | 'thinking-problem'
  | 'doc-add'
  | 'ad-product'
  | 'afferent-three'
  | 'efferent-three'
  | 'efferent-four'
  | 'people-right'
  | 'link-right'
  | 'plus'
  | 'camera'
  | 'code-brackets-two'
  | 'file-search-two'
  | 'file-success'
  | 'arrow-right'
  | 'link-in'
  | 'system'
  | 'image-files'
  | 'file-editing'
  | 'audio-file'
  | 'text-recognition';

export type IbIconTheme = 'outline' | 'filled' | 'two-tone' | 'multi-color';

export interface IIbIconProps {
  className?: string;
  iconName: IbIconName;
  size?: number;
  theme?: IbIconTheme;
  color?: string;
  fill?: string;
  spin?: boolean;
  onClick?: () => void;
}

const IbIcon: React.FC<IIbIconProps> = ({
  className,
  iconName,
  size = SIZE_DEFAULT,
  theme,
  color = COLOR_DEFAULT,
  fill,
  spin,
  onClick,
}) => {
  size = getDefaultIfUndefined(size, SIZE_DEFAULT);
  color = getDefaultIfUndefined(color, COLOR_DEFAULT);

  const classes = [MAIN_CLASS_NAME];
  className && classes.push(className);

  const props = {
    className: classes.join(' '),
    style: {
      width: size,
      height: size,
      color,
    },
    theme,
    fill,
    spin,
    onClick,
  } as IIconProps;

  switch (iconName) {
    case 'attention':
      return <Attention {...props} />;
    case 'compression':
      return <Compression {...props} />;
    case 'paperclip':
      return <Paperclip {...props} />;
    case 'add-one':
      return <AddOne {...props} />;
    case 'every-user':
      return <EveryUser {...props} />;
    case 'comment':
      return <Comment {...props} />;
    case 'comments':
      return <Comments {...props} />;
    case 'cycle':
      return <Cycle {...props} />;
    case 'speaker-one':
      return <SpeakerOne {...props} />;
    case 'branch-one':
      return <BranchOne {...props} />;
    case 'inbox':
      return <Inbox {...props} />;
    case 'key':
      return <Key {...props} />;
    case 'check-one':
      return <CheckOne {...props} />;
    case 'check-small':
      return <CheckSmall {...props} />;
    case 'edit':
      return <Edit {...props} />;
    case 'slightly-smiling-face':
      return <SlightlySmilingFace {...props} />;
    case 'view-list':
      return <ViewList {...props} />;
    case 'list-view':
      return <ListView {...props} />;
    case 'code-brackets':
      return <CodeBrackets {...props} />;
    case 'check':
      return <Check {...props} />;
    case 'delete':
      return <Delete {...props} />;
    case 'done-all':
      return <DoneAll {...props} />;
    case 'link-two':
      return <LinkTwo {...props} />;
    case 'headset-one':
      return <HeadsetOne {...props} />;
    case 'alphabetical-sorting':
      return <AlphabeticalSorting {...props} />;
    case 'at-sign':
      return <AtSign {...props} />;
    case 'lock':
      return <Lock {...props} />;
    case 'unlock':
      return <Unlock {...props} />;
    case 'next':
      return <Next {...props} />;
    case 'send':
      return <Send {...props} />;
    case 'up':
      return <Up {...props} />;
    case 'down':
      return <Down {...props} />;
    case 'search':
      return (
        <span {...props}>
          <Search />
        </span>
      );
    case 'telegram':
      return (
        <span {...props}>
          <Telegram />
        </span>
      );
    case 'viber':
      return (
        <span {...props}>
          <Viber />
        </span>
      );
    case 'whatsapp':
      return (
        <span {...props}>
          <WhatsApp />
        </span>
      );
    case 'elma365':
      return (
        <span {...props}>
          <Elma365 />
        </span>
      );
    case 'confluence':
      return (
        <span {...props}>
          <Confluence />
        </span>
      );
    case 'livechat':
    case 'directline':
      return (
        <span {...props}>
          <LiveChat />
        </span>
      );
    case 'setting-two':
      return <SettingTwo {...props} />;
    case 'help':
      return <Help {...props} />;
    case 'guardrail-input':
      return (
        <span {...props}>
          <GuardrailInput />
        </span>
      );
    case 'guardrail-output':
      return (
        <span {...props}>
          <GuardrailOutput />
        </span>
      );
    case 'login':
      return <Login {...props} />;
    case 'logout':
      return <Logout {...props} />;
    case 'pay-code-one':
      return <PayCodeOne {...props} />;
    case 'code-one':
      return <CodeOne {...props} />;
    case 'filter':
      return <Filter {...props} />;
    case 'close-small':
      return <CloseSmall {...props} />;
    case 'close':
      return <Close {...props} />;
    case 'more-one':
      return <MoreOne {...props} />;
    case 'right-bar':
      return <RightBar {...props} />;
    case 'hamburger-button':
      return <HamburgerButton {...props} />;
    case 'arrow-left':
      return <ArrowLeft {...props} />;
    case 'refresh':
      return <Refresh {...props} />;
    case 'preview-open':
      return <PreviewOpen {...props} />;
    case 'preview-close-one':
      return <PreviewCloseOne {...props} />;
    case 'return':
      return <Return {...props} />;
    case 'close-wifi':
      return <CloseWifi {...props} />;
    case 'time':
      return <Time {...props} />;
    case 'tool':
      return <Tool {...props} />;
    case 'toolkit':
      return <Toolkit {...props} />;
    case 'dot':
      return <Dot {...props} />;
    case 'drag':
      return <Drag {...props} />;
    case 'play':
      return <Play {...props} />;
    case 'play-one':
      return <PlayOne {...props} />;
    case 'play-cycle':
      return <PlayCycle {...props} />;
    case 'copy-one':
      return <CopyOne {...props} />;
    case 'copy-link':
      return <CopyLink {...props} />;
    case 'detection':
      return <Detection {...props} />;
    case 'left':
      return <Left {...props} />;
    case 'right':
      return <Right {...props} />;
    case 'robot-one':
      return <RobotOne {...props} />;
    case 'close-one':
      return <CloseOne {...props} />;
    case 'download':
      return <Download {...props} />;
    case 'download-three':
      return <DownloadThree {...props} />;
    case 'upload-three':
      return <UploadThree {...props} />;
    case 'list-top':
      return <ListTop {...props} />;
    case 'handle-x':
      return <HandleX {...props} />;
    case 's-turn-left':
      return <STurnLeft {...props} />;
    case 'redo':
      return <Redo {...props} />;
    case 'click-to-fold':
      return <ClickToFold {...props} />;
    case 'expand-text-input':
      return <ExpandTextInput {...props} />;
    case 'loading-four':
      return <LoadingFour {...props} />;
    case 'link-one':
      return <LinkOne {...props} />;
    case 'folder-plus':
      return <FolderPlus {...props} />;
    case 'file-code':
      return <FileCode {...props} />;
    case 'file-text':
      return <FileText {...props} />;
    case 'share-three':
      return <ShareThree {...props} />;
    case 'terminal':
      return <Terminal {...props} />;
    case 'pencil':
      return <Pencil {...props} />;
    case 'timer':
      return <Timer {...props} />;
    case 'user':
      return <User {...props} />;
    case 'me':
      return <Me {...props} />;
    case 'info':
      return <Info {...props} />;
    case 'adjacent-item':
      return <AdjacentItem {...props} />;
    case 'lightning':
      return <Lightning {...props} />;
    case 'vertical-tidy-up':
      return <VerticalTidyUp {...props} />;
    case 'book-one':
      return <BookOne {...props} />;
    case 'undo':
      return <Undo {...props} />;
    case 'check-correct':
      return <CheckCorrect {...props} />;
    case 'good-two':
      return <GoodTwo {...props} />;
    case 'group':
      return <Group {...props} />;
    case 'optimize':
      return <Optimize {...props} />;
    case 'server':
      return <Server {...props} />;
    case 'web-page':
      return <WebPage {...props} />;
    case 'worker':
      return <Worker {...props} />;
    case 'international':
      return <International {...props} />;
    case 'round':
      return <Round {...props} />;
    case 'clipboard':
      return <Clipboard {...props} />;
    case 'fullscreen-two':
      return <FullScreenTwo {...props} />;
    case 'offscreen-two':
      return <OffScreenTwo {...props} />;
    case 'user-business':
      return <UserBusiness {...props} />;
    case 'calendar-three':
      return <CalendarThree {...props} />;
    case 'thinking-problem':
      return <ThinkingProblem {...props} />;
    case 'doc-add':
      return <DocAdd {...props} />;
    case 'ad-product':
      return <AdProduct {...props} />;
    case 'afferent-three':
      return <AfferentThree {...props} />;
    case 'efferent-three':
      return <EfferentThree {...props} />;
    case 'efferent-four':
      return <EfferentFour {...props} />;
    case 'people-right':
      return <PeopleRight {...props} />;
    case 'link-right':
      return <LinkRight {...props} />;
    case 'plus':
      return <Plus {...props} />;
    case 'camera':
      return <Camera {...props} />;
    case 'code-brackets-two':
      return (
        <span {...props}>
          <CodeBracketsTwo />
        </span>
      );
    case 'file-search-two':
      return <FileSearchTwo {...props} />;
    case 'file-success':
      return <FileSuccess {...props} />;
    case 'arrow-right':
      return <ArrowRight {...props} />;
    case 'link-in':
      return <LinkIn {...props} />;
    case 'system':
      return <System {...props} />;
    case 'image-files':
      return <ImageFiles {...props} />;
    case 'file-editing':
      return <FileEditing {...props} />;
    case 'audio-file':
      return <AudioFile {...props} />;
    case 'text-recognition':
      return <TextRecognition {...props} />;
    default:
      return null;
  }
};

export default IbIcon;
